module.exports = __webpack_public_path__ + "img/mall91_logo.bd2ad3f9.jpg";